import React from 'react'
import { css } from "glamor";
import _ from "lodash";

import Section from "./Section";
import Nav from "../menu/Nav";
import LayoutTemplate from "./LayoutTemplate";
import H1 from "../H1";
import { mediaQueries } from "../../../constants/mediaQueries";
import { colours } from "../../../constants/colourConstants";
import CookieContainer from "../cookies/CookieContainer";
import Footer from "../footer/Footer";
import { featuresSlug, productPageList } from "../../../constants/productPageData";
import Cards from "../Cards";
import ImageWrapper from "./ImageWrapper";
import Image from './Image';
import H2 from '../H2';
import { paragraphStyles } from '../../../constants/textStyles';
import Breadcrumbs from '../menu/Breadcrumbs';
import Seo from '../Seo';
import SalesButtons from '../SalesButtons';
import { h5Styles } from '../../../constants/textStyles';

const UseCasesPageTemplate = ({
    page,
    theme = "purple",
    imageSettings,
    location
}) => {
    const features = _.find(productPageList, { id: featuresSlug });
    const themeLowerContrast = theme.includes("orange") || theme.includes("green")
    const themeBackgroundColor = themeLowerContrast ? colours.primary[theme][400] : colours.primary[theme][600]

    const renderHeaderImage = () => (
        <Image
            retinaReady
            alt={`Plexi's Veterinary ${page.title}`}
            src={page.header.image}
        />
    )

    const renderHeaderText = () => (
        <div
            {...css({
                color: colours.white,
                marginTop: 32,

                [mediaQueries.isMobile]: {
                    marginTop: 20,
                }
            })}
        >
            <Breadcrumbs activePage={page.title} />
            <img
                alt={`${page.title} icon`}
                src={page.icon}
                {...css({
                    width: 48,
                    marginBottom: 10,
                })}
            />
            <H1
                {...css({
                    color: colours.white,
                })}
            >
                {page.header.title}
            </H1>
            <H2
                {...css({
                    color: colours.white,
                    ...paragraphStyles,
                })}
            >
                {page.header.text}
            </H2>
            <SalesButtons
                themes={{
                    primaryButtonTheme: theme
                }}
                backgroundColorType="dark"
            />
        </div>
    )

    const renderSections = () => {
        const defaultImageSettings = [
            {
                location: "left",
                trianglePosition: "bottom-right",
                axisMultiplier: {
                    x: 0.2,
                    y: 0.6,
                },
                type: "block",
            }, {
                location: "right",
                trianglePosition: "bottom-left",
                axisMultiplier: {
                    x: 0.1,
                    y: 0.2,
                },
                type: "block",
            }, {
                location: "left",
                trianglePosition: "top-right",
                axisMultiplier: {
                    x: 0.2,
                    y: 0.4,
                },
                type: "block",
            }, {
                location: "right",
                trianglePosition: "top-left",
                axisMultiplier: {
                    x: 0.1,
                    y: 0.3,
                },
                type: "block",
            }
        ]

        const imageSettingSelector = imageSettings ? imageSettings : defaultImageSettings;

        return page.sections.map(({ id, title, text, image, imageAlt }, index) => {
            return (
                <Section
                    key={index}
                >
                    <LayoutTemplate
                        imageLocation={imageSettingSelector[index].location} //will currently break if we use more than 4 sections
                        title={title}
                        copy={text}
                        ImageComponent={() => (
                            <ImageWrapper
                                image={image}
                                imageStyles={imageSettingSelector[index].styles}
                                alt={imageAlt ? imageAlt : title}
                                theme={theme}
                                trianglePosition={imageSettingSelector[index].trianglePosition}
                                axisMultipliers={imageSettingSelector[index].axisMultiplier}
                                coloursObj={imageSettingSelector[index].coloursObj}
                                type={imageSettingSelector[index].type}
                            />
                        )}
                    />
                </Section>
            )
        })
    }

    const renderFeaturesLinksSection = () => {
        return (
            <Section>
                <LayoutTemplate
                    imageHeight="auto"
                    imageLocation={"bottom"}
                    title={"Transform your team’s efficiency, workflow and performance"}
                    center
                    ImageComponent={() => (
                        <Cards
                            bullets={features.pages}
                            iconLocation="top-inline-left"
                            titleStyles={css(h5Styles)}
                        />
                    )}
                />
            </Section>
        )
    }

    return (
        <div>
            <Nav heroTemplate="darkHero" backgroundColor={themeBackgroundColor} />
            <div {...css({ width: '100%' })}>
                <Seo
                    passedTitle={page.header.title}
                    passedDescription={page.header.text}
                    image={page.seoImage}
                    location={location}
                />
                <Section
                    {...css({
                        backgroundColor: themeBackgroundColor,
                    })}
                >
                    <LayoutTemplate
                        {...css({
                            overflow: "visible",
                            paddingTop: "120px",

                            [mediaQueries.isTabletPortrait]: {
                                paddingTop: "120px",
                            },
                            [mediaQueries.isMobile]: {
                                paddingTop: "80px",
                            }
                        })}
                        imageLocation={"right"}
                        imageWidth={"50%"}
                        ImageComponent={renderHeaderImage}
                        TextComponent={renderHeaderText}
                        removeTopMargin
                    />
                </Section>
                {renderSections()}
                {renderFeaturesLinksSection()}
                <Footer />
                <CookieContainer />
            </div>
        </div>
    )
}

export default UseCasesPageTemplate